var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[(_vm.logoUrl)?_c('b-col',{staticClass:"d-flex justify-content-start"},[_c('router-link',{attrs:{"to":'/' + _vm.$customerUuid + '/'}},[_c('img',{staticClass:"logo img-responsive",attrs:{"alt":"Logo organizace","src":_vm.logoUrl},on:{"load":_vm.loaded}})])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }